import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconListBullet16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconListBullet16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.5 3.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m10 .5a.5.5 0 0 0 0-1H5.475a.5.5 0 1 0 0 1zm-1.852 3a.5.5 0 1 0 0-1H5.475a.5.5 0 0 0 0 1zM14 9.5a.5.5 0 0 1-.5.5H5.475a.5.5 0 0 1 0-1H13.5a.5.5 0 0 1 .5.5M11.648 13a.5.5 0 0 0 0-1H5.475a.5.5 0 1 0 0 1zM2.75 7.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M3.5 9.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconListBullet16);
